import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import classnames from 'classnames';
import omit from 'lodash/omit';
import styles from './Popover.module.css';
const { makeStyles } = MaterialUiCore;
const { Popover: MuiPopover } = MaterialUiCore;
export default function Popover(props) {
    const { children, popoverStyles } = props;
    const useStyles = makeStyles(popoverStyles);
    const classes = useStyles(props);
    return (
        <MuiPopover
            {...omit(props, ['children', 'chevronHeight', 'popoverStyles'])}
            classes={{
                paper: classnames(styles['popover'], classes.popover),
            }}
            style={{
                overflowY: 'visible',
                overflowX: 'visible',
            }}
        >
            <div className={classnames(styles['popover__chevron'], classes['popover__chevron'])}></div>
            {children}
        </MuiPopover>
    );
}
Popover.propTypes = {
    open: PropTypes.bool.isRequired,
    popoverStyles: PropTypes.shape({}).isRequired,
    chevronHeight: PropTypes.number.isRequired,
};
